import { z } from 'zod';
import { optionalVatIdSchema } from '@/shared/lib/validation/vat-id/vat-id.schema';


export const billingAddressSchema = z.object({
    billing_address         : z.string().min(1, 'Billing address is required'),
    billing_address_extra   : z.string().optional(),
    billing_city            : z.string().min(1, 'City is required'),
    billing_country         : z.string().min(1, 'Country is required'),
    billing_email           : z.string().min(1, 'Billing email is required').pipe(z.email('Invalid email')),
    billing_email_additional: z.email('Invalid email').optional().or(z.literal('')),
    billing_postal_code     : z.string().min(1, 'Postal code is required'),
    vat_id                  : optionalVatIdSchema,
}).superRefine(({ billing_country, billing_postal_code }, ctx) => {
    if (
        billing_country === 'NL'
        && !/^\d{4}\s?[a-z]{2}$/i.test(billing_postal_code.trim())
    ) {
        ctx.addIssue({
            code   : 'custom',
            path   : ['billing_postal_code'],
            message: 'Enter a valid Dutch postal code, for example: 1234 AB',
        });
    }
});

export type BillingAddressFormData = z.infer<typeof billingAddressSchema>;
